import { render } from "./Loading.vue?vue&type=template&id=c93a377e"
const script = {}

import exportComponent from "/Users/Carl/Develop/go/src/github.com/Soesah/bazaar.vrijeschoolmarelandleiden.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__